import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'antd';
import { injectIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import Text from '../basic/Text';
import Box from '../basic/Box';
import Flex from '../basic/Flex';

const { confirm } = Modal;

function CancelModal({
  visible, onContinue, onClose, goBackOnContinue, intl,
}) {
  const history = useHistory();
  function showPropsConfirm() {
    confirm({
      title: intl.formatMessage({ id: 'generic.cancelFormText.confirm' }),
      content: intl.formatMessage({ id: 'generic.cancelFormText.warning' }),
      okText: intl.formatMessage({ id: 'generic.continuar' }),
      okType: 'danger',
      cancelText: intl.formatMessage({ id: 'pacientes.new_client.cancel' }),
      onOk() {
        if (!onContinue || goBackOnContinue) {
          history.goBack();
        } else {
          onContinue();
        }
      },
      onCancel() {
        onClose();
      },
    });
  }
  useEffect(() => {
    if (visible) {
      showPropsConfirm();
    }
  }, [visible]);

  return <></>;
}

CancelModal.propTypes = {
  visible: PropTypes.bool,
  goBackOnContinue: PropTypes.bool,
  onContinue: PropTypes.func,
  onClose: PropTypes.func,
};
CancelModal.defaultProps = {
  visible: false,
  goBackOnContinue: true,
  onContinue: false,
  onClose: () => {},
};
export default injectIntl(CancelModal);
